<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <estime v-if="sas" :sasId="sas.id"></estime>
    <introduction v-show="step == 'introduction'" endpoint="demande-reconnaissance-formation" @next-step="next"></introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import Informations from "@/components/DemandeReconnaissanceFormation/Informations"
import Formateurs from "@/components/DemandeReconnaissanceFormation/Formateurs"
import InfosActivite from "@/components/DemandeReconnaissanceFormation/InfosActivite"
import InfosCatalogue from "@/components/DemandeReconnaissanceFormation/InfosCatalogue"
import Engagements from "@/components/DemandeReconnaissanceFormation/Engagements"
import EstimationFrais from "@/components/DemandeReconnaissanceFormation/EstimationFrais"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"
import Estime from "@/components/FormParts/Estime"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/demande-reconnaissance-formation/",
      paramsName: "reconnaissance-formation",
      loadPanierOnLoad: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "informations", code: "titre-etape-1", state: "" },
        { path: "formateurs", code: "titre-etape-2", state: "" },
        { path: "infos-activite", code: "titre-etape-3", state: "" },
        { path: "infos-catalogue", code: "titre-etape-4", state: "" },
        { path: "engagements", code: "titre-etape-5", state: "" },
        { path: "estimation-frais", code: "titre-etape-6", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    Informations,
    Formateurs,
    InfosActivite,
    InfosCatalogue,
    Engagements,
    EstimationFrais,
    Soumission,
    Estime
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>